<template>

	<div class="card">
		<slot>

		</slot>
		<h2>
			<span class="title">
				{{cardData.title}}
			</span>
			<span class="key" v-for="key in cardData.keys" v-show="key" :key="key">{{key}}</span>
		</h2>
		<div class="radio" v-if="cardData.state==0">
			<span class="label">确认意见：</span>
			<el-radio v-model="form.radio" label="1">确认</el-radio>
			<el-radio v-model="radio" label="2">返回中智</el-radio>
		</div>
		<div class="radio" v-if="cardData.state==1">
			<span class="label">审批意见：</span>
			<el-radio v-model="form.radio" label="1">确认</el-radio>
			<el-radio v-model="radio" label="2">驳回</el-radio>
		</div>
		<div class="tip" v-if="cardData.state>1">
			<div>
				<img v-if="cardData.state==2||cardData.state==3" src="@/assets/img/salary/wancheng.png" alt="" srcset="">
				<img v-else src="@/assets/img/salary/icon-daweiwancheng.png" alt="" srcset="">
			</div>
			<div>
				<p v-if="cardData.state==2">您已提交审批意见，现在流程到 {{cardData.process.current}}</p>
				<p v-if="cardData.state==3">{{labels[4]}}已完成审核</p>
				<p v-if="cardData.state==4">您已驳回审批意见</p>
				<p v-if="cardData.state==5">{{labels[4]}}未完成</p>
			</div>
		</div>
		<div class="info">
			<div>
				<span>{{labels[0]}}：</span>
				<span>{{cardData.info.num1}}</span>
			</div>
			<div>
				<span>{{labels[1]}}：</span>
				<span>{{cardData.info.num2}}</span>
			</div>
			<div>
				<span>{{labels[2]}}：</span>
				<span>{{cardData.info.num3}}</span>
			</div>
			<div>
				<span>{{labels[3]}}：</span>
				<span>{{cardData.info.num4}}</span>
			</div>
		</div>
		<div class="textarea" v-if="cardData.state==1||cardData.state==0">
			<span class="label" style="vertical-align: top;padding-top:4px;">备注：</span>
			<el-input type="textarea" style="width:calc(100% - 65px)" v-model="form.adv"></el-input>
		</div>
		<div class="process" :class="{'other':cardData.state>1,'sure':cardData.state==0}">
			<span class="label">审批流程：</span>
			<span v-for="list in cardData.process.processList" :key="list" :class="{'iscurrent':list==cardData.process.current,'fail':(cardData.state==4||cardData.state==5)}">
				{{list}}
				<el-tooltip class="item" effect="light" content="当前示意到HR2环节驳回" placement="bottom">
					<img v-if="list==cardData.process.current&&(cardData.state==4||cardData.state==5)" src="@/assets/img/salary/guanbi.png" />
				</el-tooltip><span>></span>
			</span>

		</div>
		<div class="save" v-if="cardData.state==1||cardData.state==0">
			<el-button type="primary">提交</el-button>
		</div>
	</div>

</template>

<script>
	export default {
		name: "card",
		props: {
			cardData: {
				type: Object,
				default: {},
			},
			radio: {
				type: String,
				default: '1',
			},
			labels: {
				type: Array,
				default: [],
			}
		},
		data() {
			return {
				form: {
					radio: '1',
					adv: ''
				}
			};
		},
		computed: {

		},
		methods: {

		}
	};
</script>

<style scoped>
	.card {
		border: 1px solid rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 5px 0px rgba(203, 201, 201, 0.5);
		border-radius: 4px;
		padding: 14px 30px 20px 20px;
		box-sizing: border-box;
		 width:calc(33.3% - 10px);
		/*min-width: 380px; */
		margin-right: 10px;
		margin-bottom: 10px;
		min-height: auto;
		background: #fff;
		position: relative;
		overflow: hidden;
	}
	h2 {
		height: 22px;
		line-height: 22px;
	}

	h2>span {
		vertical-align: middle;
	}

	.title {
		font-size: 16px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 22px;
		margin-right: 8px;
	}

	h2>.key {
		border-radius: 2px;
		padding: 1px 4px;
		font-size: 10px;
		font-weight: 300;
		line-height: 14px;
		margin-left: 5px;
	}

	h2>.key:nth-of-type(2) {
		border: 1px solid rgba(255, 0, 0, 1);
		color: rgba(255, 0, 0, 1)
	}
  h2>.key{
    border: 1px solid rgba(255, 221, 0,1);
    color: rgb(255, 221, 0)
  }
	h2>.key:nth-of-type(3) {
		border: 1px solid rgba(1, 167, 59, 1);
		color: rgba(1, 167, 59, 1);
	}

	h2>.key:nth-of-type(4) {
		border: 1px solid rgba(241, 137, 27, 1);
		color: rgba(241, 137, 27, 1);
	}

	.radio {
		padding: 8px 0 6px;
	}

	.card .label {
		display: inline-block;
		font-size: 13px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
		width: 65px;
		text-align: right;
	}

	.info {
		display: flex;
		background: rgba(243, 243, 243, 1);
		border-radius: 4px;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-top: 2px;
	}

	.info>div {
		width: calc(50% - 45px);
		display: flex;
		justify-content: space-between;
		padding: 7px 10px 6px 7px;
	}

	.info>div>span:nth-of-type(1) {
		font-size: 13px;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.info>div>span:nth-of-type(2) {
		font-size: 13px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.textarea {
		margin-top: 10px;
	}

	.process {
		padding-top: 6px;
	}

	.process>span {
		font-size: 13px;
		font-weight: 600;
		color: rgba(0, 0, 0, 1);
		line-height: 18px;
	}

	.process>span.fail.iscurrent {
		color: rgba(255, 0, 0, 1);
	}

	.process>span.fail img {
		margin-left: 4px;
	}

	.process>.iscurrent~span {
		color: #666;
	}

	.process>span:nth-last-of-type(1) span {
		display: none;
	}

	.process>span>span {
		color: #666;
		padding: 0 4px;
	}

	.sure {
		visibility: hidden;
	}

	.save {
		margin-top: 10px;
		text-align: center;
	}

	.tip {
		padding-top: 40px;
		padding-bottom: 27px
	}

	.tip>div {
		text-align: center;
	}

	.tip>div img {
		display: block;
		margin: 0 auto 6px;
		width: 30px;
	}

	.tip>div p {
		font-size: 13px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.other {
		padding-top: 16px;
	}
</style>
